module.exports = __webpack_public_path__ + "static/media/cross.f5651def.svg";